import React, { useEffect } from "react";
import { Record, TabbedForm } from "react-admin";
import { SubscriptionFormGeneralInfoTab } from "./SubscriptionFormGeneralInfoTab";
import { RecordStatus } from "../../../common/data/service-proxies";
import { SubscriptionFormFeaturesTab } from "./SubscriptionFormFeaturesTab";
import { SubscriptionFormEldsTab } from "./SubscriptionFormEldsTab";

interface SubscriptionFormProps {
  record?: Record;
}

export const SubscriptionForm = (props: SubscriptionFormProps) => {
  useEffect(() => {
    if (!props.record) {
      return;
    }

    // Handle differences between the list and form models
  }, [props.record]);

  useEffect(() => {
    if (!props.record) {
      return;
    }

    // Set the record status to active, if not set
    if (!props.record.status) {
      props.record.status = RecordStatus.Active;
    }
  }, [props.record]);

  return (
    <TabbedForm className="form-create-edit" variant="outlined" {...props}>
      <SubscriptionFormGeneralInfoTab />
      <SubscriptionFormFeaturesTab />
      <SubscriptionFormEldsTab />
    </TabbedForm>
  );
};
